import script from "./FuelEfficiencySection.vue?vue&type=script&setup=true&lang=js"
export * from "./FuelEfficiencySection.vue?vue&type=script&setup=true&lang=js"

import "./FuelEfficiencySection.vue?vue&type=style&index=0&id=2243c098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2243c098"]])

export default __exports__